import { useEffect, useState } from 'react';
import { getSessionStorage, setSessionStorage } from '@/shared/lib/storage';

/**
 * Emptyモードの状態を管理するフック
 * セッションストレージに状態を保存
 */
export const useEmptyMode = () => {
  const [isEmptyMode, setIsEmptyMode] = useState<boolean>(() =>
    getSessionStorage('debug-empty-mode'),
  );

  useEffect(() => {
    setSessionStorage('debug-empty-mode', isEmptyMode);
  }, [isEmptyMode]);

  const toggleEmptyMode = (isEmptyMode: boolean) => {
    setIsEmptyMode(isEmptyMode);
  };

  return {
    isEmptyMode,
    toggleEmptyMode,
    setIsEmptyMode,
  };
};
